import { render, staticRenderFns } from "./forYou.vue?vue&type=template&id=7117acac"
import script from "./forYou.vue?vue&type=script&lang=ts"
export * from "./forYou.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports